// src/components/PageLayout.jsx
import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import BottomTabs from './BottomTabs';
import TopBar from './TopBar';

export default function PageLayout({
  title: _title,
  children,
  /** laisse un "safe area" pour la bottom bar (88px + safe-area) */
  padBottom = true,
}) {
  const slideRef = useRef(null);
  const location = useLocation();

  // Bandeau PREPROD forcé si on est sur mus.gridwise.fr (ou si REACT_APP_ENV=preprod)
  const isPreprod = React.useMemo(() => {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const onPreprodHost = /(^|\.)mus\.gridwise\.fr$/i.test(host);
    const byEnv =
      String(process.env.REACT_APP_ENV || process.env.REACT_APP_STAGE || '').toLowerCase() ===
      'preprod';
    return onPreprodHost || byEnv;
  }, []);

  // Animation d'entrée fluide au chargement de la page
  const animateIn = useCallback(() => {
    const slide = slideRef.current;
    if (!slide) return;
    requestAnimationFrame(() => {
      slide.style.transition = 'none';
      slide.style.opacity = '0.98';
      slide.style.transform = 'translateX(24px)';
      requestAnimationFrame(() => {
        slide.style.transition = 'transform 220ms cubic-bezier(.22,.61,.36,1), opacity 220ms';
        slide.style.transform = 'translateX(0px)';
        slide.style.opacity = '1';
      });
    });
  }, []);

  useEffect(() => {
    animateIn();
  }, [location.pathname, animateIn]);

  return (
    <div
      className="min-h-dvh bg-[#FAFAFA] text-[#1C1C1C]"
      style={{ overscrollBehaviorX: 'contain' }}
    >
      {isPreprod && (
        <>
          <div
            className="fixed top-[55px] inset-x-0 z-[1000] text-center text-[13px] font-semibold bg-amber-500/95 text-black shadow"
            style={{ padding: '6px 8px' }}
          >
            ⚠️ Environnement <span className="underline">PREPROD</span> – données de test uniquement
          </div>
          {/* pousse le contenu sous le bandeau */}
          <div style={{ height: 36 }} />
        </>
      )}

      <main
        className={
          'max-w-screen-xl mx-auto w-full px-4 py-4 ' +
          (padBottom ? 'pb-[calc(88px+env(safe-area-inset-bottom))]' : '')
        }
      >
        <TopBar />
        <div
          ref={slideRef}
          className="will-change-transform transition-[transform,opacity]"
          style={{ transform: 'translateX(0px)', opacity: 1 }}
        >
          {children}
        </div>
      </main>

      <BottomTabs data-bottom-tabs />
    </div>
  );
}